import { isDefaultLocale } from '../../../modules/i18n/locales';

const calculateRowHeight = ({ page }) => {
  let height = 42;

  if (!page) {
    return height;
  }

  if (page.facility) {
    height += 28;
  }

  if (!isDefaultLocale(page.locale)) {
    height += 20;
  }

  return height;
};

export default calculateRowHeight;
